import { Link } from "react-router-dom";
import useReveal from "../hooks/useReveal";
import "./About.css";
import laksh from "../../src/assets/LM.png";
import ashish from "../../src/assets/AP.png";
import ankit from "../../src/assets/AD.png";
import jugal from "../../src/assets/JB.png";
import ak from "../../src/assets/AK.png";
import { config } from "../config";

const VALUES = [
  {
    icon: "⚡",
    title: "Innovation First",
    desc: "We push creative and technical boundaries on every single project.",
  },
  {
    icon: "🎯",
    title: "Client-Centric",
    desc: "Every decision is driven by delivering maximum value to our clients.",
  },
  {
    icon: "🏆",
    title: "Excellence",
    desc: "We hold ourselves to the highest standards in design and code.",
  },
  {
    icon: "🌍",
    title: "Global Impact",
    desc: "Our solutions reach and inspire audiences all around the world.",
  },
];

const TEAM = [
  {
    name: "Ankit Dubey",
    role: "Founder & CEO",
    // image: ankit,
    desc: "As the Founder and CEO, they drive strategic vision and operational excellence, ensuring impactful growth.",
  },
  {
    name: "Ashish Parmar",
    role: "Founder & Tech Lead",
    // image: ashish,
    desc: "Passionate founder driving innovative web development solutions, empowering businesses with cutting-edge technology.",
  },
  {
    name: "Laksh Maheshwari",
    role: "Founder & Marketing Head",
    // image: laksh,
    desc: "Visionary founder driving brand growth through innovative strategies and data-driven insights.",
  },
  {
    name: "Jugal Baraiya",
    role: "Social Media Manager",
    // image: jugal,
    desc: "Creative social media manager crafting engaging content and growing brand presence across all platforms.",
  },
];

export default function About() {
  useReveal();
  return (
    <div className="about-page">
      {/* PAGE HERO */}
      <div className="page-hero">
        <span className="ph-eye">Who We Are</span>
        <h1 className="ph-title">
          The Team Behind <span className="g">CubeX Technology</span>
        </h1>
        <p className="ph-sub">
          A passionate collective of designers, developers, and strategists
          united by one mission - crafting digital experiences that transform
          businesses.
        </p>
      </div>

      {/* MISSION */}
      <section className="ab-mission">
        <div className="container">
          <div className="ab-grid">
            <div className="rl">
              <div className="ab-visual">
                <div className="ab-cube">
                  <span>
                    CUBE<span style={{ fontSize: "2.2rem" }}>X</span>
                  </span>
                  <div className="ab-ring r1" />
                  <div className="ab-ring r2" />
                  <div className="ab-ring r3" />
                </div>
                <div className="ab-badge ab-badge--1">⚡ Award Winning</div>
                <div className="ab-badge ab-badge--2">🌍 20+ Countries</div>
              </div>
            </div>
            <div className="rr">
              <span className="s-eye">Our Mission</span>
              <h2 className="s-title">
                Building Tomorrow's <span className="g">Digital Landscape</span>
              </h2>
              <p className="s-body">
                Founded in 2024, CubeX Technology was born from a belief that
                every business deserves a powerful, beautiful digital presence.
                We combine technical mastery with creative excellence to deliver
                solutions that shatter expectations.
              </p>
              <p className="s-body" style={{ marginTop: "1rem" }}>
                We bring the same relentless commitment to quality and
                innovation to every project we take on.
              </p>
              <Link
                to={`${config.appUrl}contact`}
                className="btn-primary"
                style={{ marginTop: "2.5rem", display: "inline-flex" }}
              >
                Work With Us →
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* VALUES */}
      <section className="ab-values">
        <div className="container">
          <div className="tc reveal">
            <span className="s-eye">Our Values</span>
            <h2 className="s-title">
              Principles That <span className="g">Drive Us</span>
            </h2>
          </div>
          <div className="values-grid">
            {VALUES.map((v, i) => (
              <div className={`value-card reveal d${i + 1}`} key={v.title}>
                <div className="value-icon">{v.icon}</div>
                <h3>{v.title}</h3>
                <p>{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* TEAM */}
      <section className="ab-team">
        <div className="container">
          <div className="tc reveal">
            <span className="s-eye">Meet the Team</span>
            <h2 className="s-title">
              The Minds Behind <span className="g">the Magic</span>
            </h2>
          </div>
          <div className="team-grid">
            {TEAM.map((m, i) => (
              <div className={`team-card reveal d${i + 1}`} key={m.name}>
                <div className="team-avatar">
                  {/* ✅ render as <img> tag */}
                  {/* <img
                    src={m.image}
                    alt={m.name}
                    className="team-img"
                    onError={(e) => {
                      e.target.src = "/assets/placeholder.jpg";
                    }}
                  /> */}
                </div>
                <div className="team-name">{m.name}</div>
                <div className="team-role">{m.role}</div>
                <p className="team-desc pt-1">{m.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <div className="cta-sect">
        <div className="cta-glow" />
        <div
          className="container"
          style={{ position: "relative", textAlign: "center" }}
        >
          <div className="reveal">
            <h2 className="cta-title">
              Ready to Work <span className="g">Together?</span>
            </h2>
            <p className="cta-body">
              Let's start a conversation about how CubeX can elevate your
              digital presence.
            </p>
            <Link to={`${config.appUrl}contact`} className="btn-primary">
              Get in Touch →
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
